import { fetchApi } from "../../utils/fetchApis";

const questionaireURL = 'questionnaire/get';
const questionaireSaveURL = 'questionnaire/save';
const saveStatusURL = 'member/profile/status';
const getAvatarURL = 'galleries/profile/avatar';
const deleteRegionURL = 'questionnaire/delete/region';
const deleteProximityURL = 'questionnaire/delete/proximity';
const profileQuestionURL = 'questionnaire/get/profile/questions';
const galleryURL = 'galleries';
const imageURL = 'galleries/image';
const shareGalleryURL = 'galleries/share';
const uploadImageURL = 'images';
const updateImgOrderURL = 'images/rearrange';
const updateImageURL = 'batch';
const updateImgURL = 'image';
const getAllGalleriesURL = 'galleries/all';
const cropImageURL = 'edit';
const questionnaireIdURL = 'questionnaire/get/ids';
const deleteAvatarURL = 'member/avatar'

export const getQuestionaireURL = (header, id) => fetchApi(`${questionaireURL}/${id}`, 'GET', header);

export async function saveQuestionaire(data, header) {
  let body;
  if (data?.questionnaireId === 12 || data?.questionnaireId === 13) {
    body = {
      "questionnaireId": data.questionnaireId,
      "regionAnswerRequest": data.answers,
    }
  } else {
    body = {
      "questionnaireId": data.questionnaireId,
      "request": data.answers
    }
  }
  return fetchApi(`${questionaireSaveURL}`, 'POST', header, body, true, false);
}

export async function saveStatus(data, header) {
  if (data) {
    return fetchApi(`${saveStatusURL}`, 'PUT', header, data, true);
  }
}

export async function getMyProfileData(header, myProfileURL) {
  return fetchApi(`${myProfileURL}`, 'GET', header, null);
}

export async function getAvatar(header) {
  return fetchApi(`${getAvatarURL}/${header.avatarId}`, 'GET', header, null, false, true);
}

export async function deleteRegion(header, regionRequestId, answerId) {
  return fetchApi(`${deleteRegionURL}/${regionRequestId}/${answerId}`, 'DELETE', header, null, false);
}

export async function deleteProximity(header, proximityRequestId, answerId) {
  return fetchApi(`${deleteProximityURL}/${proximityRequestId}/${answerId}`, 'DELETE', header, null, false);
}

export async function getProfileQustions(header, id) {
  return fetchApi(`${profileQuestionURL}/${id}`, 'GET', header, null, false, false, true);
}

export async function getGallery(header) {
  return fetchApi(`${galleryURL}`, 'GET', header);
}

export async function getImage(header) {
  return fetchApi(`${imageURL}/${header.id}`, 'GET', header, null, false, true);
}

export async function addGallery(data) {
  return fetchApi(`${galleryURL}`, 'POST', data, data.newGalleryName);
}

export async function RenameOrDeleteGallery(data) {
  return fetchApi(`${galleryURL}/${data.body.id}`, 'PUT', data, data.body, true);
}

export async function shareGallery(data) {
  return fetchApi(`${shareGalleryURL}/${data.body.id}`, 'PUT', data, data.body, true);
}

export async function uploadImage(imageData) {
  return fetchApi(`${galleryURL}/${imageData.id}/${uploadImageURL}`, 'POST', imageData, imageData.form, false, false, true);
}

export async function cropImage(imageData) {
  return fetchApi(`${galleryURL}/${imageData.galleryId}/${imageData.mediaId}/${cropImageURL}`, 'POST', imageData, imageData.form, false, true, true);
}

export async function updateImage(image) {
  return fetchApi(`${galleryURL}/${image.galleryId}/${updateImageURL}`, 'PUT', image, image.updatedImages, true);
}

export async function updateImageMetadata(image) {
  return fetchApi(`${galleryURL}/${image.id}/${updateImgURL}`, 'PUT', image, image.renameData, true);
}

export async function updateImageRearrange(datas) {
  return fetchApi(`${galleryURL}/${datas.id}/${updateImgOrderURL}`, 'PUT', datas, datas.sortOrderData, true);
}

export async function getAllGalleries(header) {
  return fetchApi(`${getAllGalleriesURL}`, 'GET', header, null, false, false, true);
}

export async function getSuggestionToshareGallery(payload) {
  const header = {
    accessToken: payload.accessToken,
    language: payload.language
  }
  const params = `search=${payload?.search}&pageNo=${payload?.pageNo}&pageSize=${payload?.pageSize}`;
  return fetchApi(`${shareGalleryURL}/${payload.galleryId}/members?${params}`, 'GET', header, null);
}

export async function getQuestionaireId(header) {
  return fetchApi(`${questionnaireIdURL}`, 'GET', header);
}

export async function getAllGalleriesForMyprofile(header, category) {
  return fetchApi(`${galleryURL}/${category}`, 'GET', header, null, false, false, true);
}

export async function deleteAvatar(header, category) {
  return fetchApi(`${deleteAvatarURL}/${category}`, 'DELETE', header, null, false);
}